// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33fki","selected":"styles_selected__3itv6"};